const slaMapping: { [k: string]: string } = {
  YBR01: "Road Truck",
  YPRT_AIREX: "Air Exp",
  YPRT_AIRST: "Air Std",
  YPRT_B: "Base",
  YPRT_CONSL: "Consolidated to Canada",
  YPRT_COUR: "Courier",
  YPRT_DC: "Dealer Choice",
  YPRT_DDPRE: "Dedicated Service",
  YPRT_EXP: "Express",
  YPRT_H_B: "Base Hazardous",
  YPRT_H_EXP: "Express Hazardous",
  YPRT_H_SD: "Standard Hazardous",
  YPRT_LTL: "LTL",
  YPRT_MDPLU: "Priority Afterhours",
  YPRT_MDSTA: "MD Standard",
  YPRT_NDSP: "Next Day Small Parcel",
  YPRT_PCA: "Priority Canada",
  YPRT_RDEX: "Road Exp",
  YPRT_RDST: "Road Std",
  YPRT_RPLN: "Stock Transfer Order",
  YPRT_SCA: "Standard Canada",
  YPRT_SD: "Standard",
  YPRT_SEA: "Sea",
  YPRT_WC: "Will Call",
  YPRT_WS: "Weekend Service",
  YRT_2DA: "Priority 2nd Day",
  YRT_AKA: "Ascent Alaska Air",
  YRT_DDPRE: "Next Day Pre8AM",
  YRT_FP1: "FedEX Priority 1",
  YRT_GRD: "Standard Ground",
  YRT_GRND: "Ground",
  YRT_HWA: "Priority Heavyweight Air",
  YRT_ND: "Next Day Road",
  YRT_NDA: "Priority Next Day",
  YRT_NDEA: "Next Day Air Early AM",
  YRT_NXTD: "Next Day",
  YRT_POP65: "PROP65 CALIFORNIA",
  YRT_SADD: "Saturday Day Delivery",
  YRT_SATD: "Priority Saturday",
  YRT_SATP: "UPS Saturday Pickup",
  YRT_SNDA: "Second Day Air",
  YRT_SPU: "Saturday Pick Up",
  YRT_THP: "THP Service",
  YTR1: "Van",
  YTR2: "Truck",
  YPRTS_2D: "2 Day Shipping",
  YPRTS_3D: "3 Day Shipping",
  YPRTS_SD: "Standard Shipping",
  YPT2: "Transportation unit",
  YPTS: "Transportation unit - Sunbelt",
};

const slaInverseMapping: { [name: string]: string } = {};
Object.entries(slaMapping).forEach(([serviceCode, serviceName]) => {
  slaInverseMapping[serviceName.toString().toUpperCase()] = serviceCode;
});

export const getServiceCodeForSLAName = (name: string) =>
  slaInverseMapping[name.toUpperCase().replace(/_/g, " ")];
